import { mapState } from 'vuex';

/**
 * Web / Mobile (Android&iOS) InfinityScroll
 * Credted::2021-10-06 / By.Sang
 */
export const InfinityScrollMixin = {
    data() {
        return {
            page: 0,
            limit: 10,
            setTime: 0,
            scrollCount: 0,
            scrollPause: false,
            doneFlag: false,
            phoneDevice: localStorage.getItem('phoneDevice'),
        }
    },
    computed: {
        ...mapState({
            reviewItems: state => state.review.items,
            totalCount: state => state.review.totalCount,
        })
    },
    methods: {
        checkScrollEnd() {
            if(this.doneFlag)
                return;

            let mainContent = document.getElementById('app');

            if (mainContent) {
                let scrollEnd = mainContent.offsetHeight - (window.pageYOffset+window.innerHeight);
                if (scrollEnd<1)
                {
                    setTimeout(() => {
                        if(this.scrollCount!=0 || this.scrollPause)
                            return;

                        this.getContentList();
                        this.scrollPause = true;
                        this.scrollCount++;

                    }, this.setTime);

                    this.scrollCount = 0;
                }
            }
        },

        setScroll() {
            this.setTime = this.phoneDevice=='iOS' ? 1000 : 500;
            document.addEventListener("touchmove", this.setTouchmove, false); 
            document.addEventListener("scroll", this.setOnScroll, false);
        },
        removeScroll() {
            document.removeEventListener("touchmove", this.setTouchmove, false); 
            document.removeEventListener("scroll", this.setOnScroll, false);
            window.onscroll = '';
        },

        // 아이폰 스크롤 처리   20.10.07    sang
        setTouchmove() {
            this.checkScrollEnd();
        },
        // Android && web 스크롤 처리   20.10.07    sang
        setOnScroll() {
            if(this.phoneDevice!='iOS')
                window.onscroll = ()=>{ this.checkScrollEnd(); };
            else
                this.checkScrollEnd();
        },

        // 스크롤 end 로 contents 를 불러올 때, 검색 옵션 변경 시 기존 데이터 초기화
        changeSearchOption() {
            if(this.phoneDevice!='iOS') {
                window.onscroll = '';
            }

            this.page = 0;
            this.doneFlag = false;
            
            if(this.phoneDevice!='iOS')
                window.onscroll = ()=>{ this.checkScrollEnd(); };

            this.getContentList();
        },
    },

};